import { jsx as o, jsxs as c } from "react/jsx-runtime";
import { CloseIcon as h } from "@systemeio/ui/icons";
import { ListBoxSelect as f, Tooltip as u } from "@systemeio/ui";
import { useEditorState as g } from "../../node_modules/@tiptap/react/dist/index.mjs";
import { useMemo as z } from "react";
import { useTranslation as S } from "../../i18n.mjs";
import C from "../../icons/font-size-icon.mjs";
import { ToolbarSelectButton as I } from "../../components/content-controls/toolbar-select-button.mjs";
import { TOOLTIP_STYLES as p } from "../../constants/default-styles.mjs";
import { getFontSizeValues as b } from "./utils/font-size.mjs";
import { twMerge as F } from "tailwind-merge";
import { isImageSelected as N } from "../image-extension/utils/is-image-selected.mjs";
const k = (a, s) => {
  const { t: i } = S(), l = g({
    editor: a,
    selector: ({ editor: e }) => ({
      isEditable: (e == null ? void 0 : e.options.editable) ?? !1,
      fontSize: (e == null ? void 0 : e.getAttributes("textStyle").fontSize) || null,
      isImageSelected: N(e)
    })
  }), t = !(l != null && l.isEditable) || !!(l != null && l.isImageSelected), r = (l == null ? void 0 : l.fontSize) ?? null;
  return z(() => {
    const e = (n) => {
      if (!a) return null;
      n ? a.chain().focus().setFontSize(n).run() : a.chain().focus().unsetFontSize().run();
    }, m = (n, x) => /* @__PURE__ */ o("div", { className: "flex items-center", children: /* @__PURE__ */ c(I, { className: "flex gap-1", disabled: t, open: n, children: [
      r ?? /* @__PURE__ */ c("div", { className: "flex items-center justify-center gap-1", children: [
        /* @__PURE__ */ o(
          C,
          {
            className: F(
              "main-transition-colors h-3.5 w-3.5 scale-125",
              t ? "fill-text-secondary" : "fill-text-primary group-hover:fill-brand-primary"
            )
          }
        ),
        x
      ] }),
      (s == null ? void 0 : s.clearable) && !!r && /* @__PURE__ */ o(
        h,
        {
          onClick: (d) => {
            d.stopPropagation(), e(null);
          },
          className: "fill-text-primary cursor-pointer"
        }
      )
    ] }) });
    return {
      toolbarRender: /* @__PURE__ */ o(
        f,
        {
          optionsProps: { unmount: !1 },
          optionsClassName: "min-w-[100px] w-[100px]",
          disabled: t,
          value: r,
          onChange: e,
          data: b(),
          children: (n) => /* @__PURE__ */ o(u, { disabled: t, label: i("font_size"), anchor: "left", ...p, children: m(n) })
        }
      ),
      tooltipRender: /* @__PURE__ */ o(
        f,
        {
          optionsProps: { unmount: !1 },
          optionsClassName: "z-40 min-w-[100px] w-[100px]",
          disabled: t,
          value: r,
          onChange: e,
          data: b(),
          children: (n) => /* @__PURE__ */ o(u, { disabled: t, label: i("font_size"), anchor: "left", ...p, children: m(n, i("font_size")) })
        }
      )
    };
  }, [a, t, s == null ? void 0 : s.clearable, r, i]);
};
export {
  k as useFontSizeExtensionToolbar
};
